<script lang="ts" setup>
  import { useDisplay } from 'vuetify/framework'

  interface Props {
    showCloseButton?: boolean
    maxWidth?: string | number
    fullscreen?: boolean
  }

  const props = withDefaults(defineProps<Props>(), {
    showCloseButton: true,
    maxWidth: '390',
    fullscreen: false,
  })
  const emit = defineEmits<{ 'after-leave': [] }>()

  const dialogRef = ref<HTMLElement | null>(null)

  const model = defineModel({
    type: Boolean,
    default: false,
  })

  const { mobile } = useDisplay()

  function close () {
    model.value = false
  }
</script>

<template>
  <v-dialog
    v-model="model"
    :fullscreen="props.fullscreen"
    :max-width="props.maxWidth"
    @after-leave="emit('after-leave')"
  >
    <v-card
      ref="dialogRef"
      class="bg-login-bg"
      :class="{
        'rounded-1xl' : !mobile,
      }"
    >
      <v-card-item v-if="props.showCloseButton || $slots.header" class="px-4">
        <div class="d-flex justify-space-between align-center">
          <v-card-title v-if="$slots.header" class="text-h6">
            <slot name="header" />
          </v-card-title>
          <v-btn
            v-if="props.showCloseButton"
            color="grey-500"
            density="comfortable"
            icon
            variant="text"
            @click="close"
          >
            <v-icon icon="mdi-close" />
          </v-btn>
        </div>
      </v-card-item>

      <v-card-text class="p-6">
        <slot />
      </v-card-text>

      <v-card-actions v-if="$slots.footer" class="pa-4 pt-0">
        <slot name="footer" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" scoped>

:deep(.v-card) {
  box-shadow: none !important;
}
</style>
